import { httpRequest } from "@services/http";

export class CommandDeleteNetworkTemplate {
  // The server refuses (409) a template a launch still points at, and says which launches.
  // That message is worth showing verbatim: it is the only place the caller can find out.
  async run(templateId: number): Promise<void> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/network_templates/${templateId}/`;
    await httpRequest<void>(url, { method: "DELETE" });
  }
}
